import React, { useState } from 'react';
import './About.css';
import Footer from '../Footer';
import HeroSection from '../HeroSection';
import Offer from '../Offer';
import StatsSection from '../StatsSection';
import FeaturedEvent from '../FeaturedEvent';
import Newsletter from '../Newsletter';
import VideoModal from '../VideoModal';
import arrowIcon from "./assets/svg/arrow.svg";
import playIcon from "./assets/svg/status-play.svg";
import abouthero from './assets/abouthero.jpg';
import testimonialImage from './assets/ancsel_eva.jpg';
import placeholderImage from './assets/image.png';

function About() {
  const [openVideoIndex, setOpenVideoIndex] = useState(null);

  const videoCards = [
    {
      title: 'Title goes here',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      link: '#'
    },
    {
      title: 'Title goes here',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      link: '#'
    },
    {
      title: 'Title goes here',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      link: '#'
    }
  ];

  return (
    <main className="about-page">
      {openVideoIndex !== null && (
        <VideoModal onClose={() => setOpenVideoIndex(null)} />
      )}

      <HeroSection
        title="Rólunk"
        text="A Beszédzavarral Élők Jóllétéért (beszÉLJ!) Egyesületet 2024 nyarán alapították olyan érintettek, akik maguk is dadogással és/vagy hadarással élnek. Mi vagyunk az első magyarországi szervezet, amelyet teljes egészekben érintettek hoztak létre és működtetnek, ezért pontosan értjük az érintettek és családjaik kihívásait. Célunk az életminőség javítása, a közösségi támogatás erősítése és a társadalmi szemléletformálás. Rendszeresen szervezünk közösségi programokat és erős online jelenléttel dolgozunk azért, hogy minden érintett hangja számítson – beszÉLJ!"
        customVisual={<img src={abouthero} alt="Rólunk" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center", display: "block", borderRadius: "4px" }} />}
      />
      <Offer />
      <StatsSection />

      {/* <section className="video-section">
        <h2 className="video-heading title-sm">Title goes here</h2>
        <div className="video-cards-container">
          <div className="video-cards-background"></div>
          <div className="video-cards">
            {videoCards.map((card, i) => (
              <div className="video-card-wrapper" key={i}>
                <div className="video-card">
                  <div
                    className="video-placeholder"
                    role="button"
                    tabIndex={0}
                    aria-label="Lejátszás"
                    onClick={() => setOpenVideoIndex(i)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") setOpenVideoIndex(i);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={playIcon}
                      alt="Lejátszás"
                      className="video-play-icon"
                    />
                  </div>
                  <h3 className="heading-md">{card.title}</h3>
                  <p className="body-sm">{card.description}</p>
                  <a href={card.link}>Learn more <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" /></a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="article-section">
        {[1, 2, 3, 4].map((_, i) => (
          <div className={"article-block" + (i % 2 === 1 ? ' reverse' : '')} key={i}>
            <div className="article-image">
              <img src={placeholderImage} alt="" />
            </div>
            <div className="article-text">
              <h3 className="heading-sm">Title goes here</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            </div>
          </div>
        ))}
      </section> */}

      <Newsletter />
      <FeaturedEvent />

      <section className="testimonial-section">
        <div className="testimonial-content">
          <div className="testimonial-image-box">
            <img src={testimonialImage} alt="Idézet illusztráció" className="testimonial-img" />
          </div>
          <div className="testimonial-quote">
            <p className="quote-text">„A dadogás az élő beszéd gondolatjelekben gazdag központozása (...) nem pusztán beszédhiba, hanem a gondolkodás és az őszinte közlés egyik legmélyebb metaforája."</p>
            <p className="quote-author">Ancsel Éva</p>
            <p className="quote-position">filozófus</p>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default About;